<div class="flex flex-col gap-4">
  <p i18n>Here you can generate a personal registration token for device inboxes that lasts for 10 minutes.</p>

  @if (registrationTokenFormData()) {
    <mat-card>
      <mat-card-header>
        <mat-card-title i18n>Active Registration Token</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col gap-4">
          <ul>
            <li class="flex flex-row items-center">
              <ng-container i18n>Token</ng-container>: <rxap-copy-to-clipboard [value]="registrationTokenFormData()?.registrationToken"></rxap-copy-to-clipboard>
            </li>
            <li class="flex flex-row items-center">
              <ng-container i18n>Expires at</ng-container>: {{ registrationTokenFormData()?.expiresAt | dateWithTimeAgo : true : 'dd-MM-yyyy HH:mm:ss' }}
            </li>
          </ul>
        </div>
      </mat-card-content>
    </mat-card>

    <button class="w-fit" mat-raised-button color="primary" (click)="createOrRefreshToken()">
      <mat-icon>refresh</mat-icon>
      <span i18n>Refresh Token</span>
    </button>
  } @else {
    <p class="text-yellow-500" i18n>No active tokens.</p>
    <button class="w-fit" mat-raised-button color="primary" (click)="createOrRefreshToken()">
      <mat-icon>add</mat-icon>
      <span i18n>Generate New Token</span>
    </button>
  }
</div>
